import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NormativaComponent } from './normativa.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [NormativaComponent],
  exports:[NormativaComponent]
})
export class NormativaModule { }
